import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { gEnums } from 'global/enums/globalEnums';
import { settingsHelpers } from 'global/viewSettings/helpers/settingsHelpers';
import { mediaHelpers } from 'global/viewSettings/importing/mediaResults';
import { useCallback, useContext, useMemo } from 'react';
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext';
import { _sportsFormProps, SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { _sdm } from '../elements/dashboard/SportsDashboard';
import { _fetchModes } from '../elements/matches/MatchDataUpdate';
import { ammendMatchesFromGsOrMedia } from '../cnr/reducers/reducerHelpers/seasonSportsMatchData';

const useGoogleSports = ({
  currentMenuKey,
  sportsDataMode,
  matches_info,
  gameScoringType,
}) => {

  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt, mainDb } = app_state

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}
  const gls_score = gls_scores?.[pathViews?.sports]

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    teams_info,
    currentSeason_info,
  } = sportsSeason_state ?? {}

  const { latestSeason, _sportsAbr } = currentSeason_info ?? {}

  const teams = teams_info?.teams

  const formProps = useMemo(() => {
    const _form_props = _sportsFormProps[sportsDataMode]
    const _appFormItems = {}
    if (_form_props) {
      Object.keys(_form_props).forEach(fp => {
        _appFormItems[fp] = settingsHelpers.newPropEditItem(fp, gEnums.formItemTypes.text, null, null, true)
      })
    }
    return _form_props
  }, [sportsDataMode])

  const linkValues = useMemo(() => {
    const _linkValues = {}
    switch (sportsDataMode) {
      case _sdm.district.updateDistrictSeasonScores:
        const xxx = gls_scores && currentMenuKey && gls_scores[currentMenuKey] ? gls_scores[currentMenuKey] : {}
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = xxx ? xxx[fp] : null
          })
        }
        break;
      default:
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = gls_score?.[fp] || null
          })
        }
    }
    return _linkValues
  }, [currentMenuKey])


  const getGsCallValues = (opts) => {
    let forMedia;
    let forPlayoffs
    let usePure;
    const { fetchMode } = opts
    const gsValues = _.clone(linkValues)
    gsValues.fetchMode = fetchMode
    switch (fetchMode) {
      case _fetchModes.results:
        gsValues.sheetName = linkValues.scoresSheet
        break;
      case _fetchModes.playoffResults:
        gsValues.sheetName = linkValues.playoffScoresSheet
        forPlayoffs = true
        break;
      case _fetchModes.resultsMedia:
        gsValues.sheetName = linkValues.scoresSheet
        forMedia = true
        break;
      case _fetchModes.playoffResultsMedia:
        forPlayoffs = true
        forMedia = true
        gsValues.sheetName = linkValues.playoffScoresSheet
        break;
      case _fetchModes.wpialResults:
        gsValues.googleSheetsId = '1ntWkPyKV9DYdwDcBDYshATj2HAfI-iAzYHHV48UYgN0'
        gsValues.sheetName = '3A Results'
        gsValues.ignoreStartCase = true
        usePure = true
        break;
      default:
      // nothing
    }
    return { gsValues, forMedia, forPlayoffs, usePure }
  }

  const getMedia_results = useCallback(
    async ({ year, dateGroupKeys, forPlayoffs, forRefresh, callback }) => {
      mediaHelpers.getMedia_results(
        dateGroupKeys,
        forPlayoffs,
        gls_score,
        year,
        _sportsAbr,
        teams,
        forRefresh,
        callback
      )
    }, []);

  const handleGet_gsMatches = useCallback(
    async ({ opts, matches_flat, callback }) => {
      const cb_ammend = (matchResultsInfo) => {
        console.log('matchResultsInfo', matchResultsInfo)
        callback(matchResultsInfo)
      }
      const cb_gs = (gsValues, results_gs, team) => {
        const action = { gsValues, results_gs, team, forPlayoffs }
        console.log('action', action)
        ammendMatchesFromGsOrMedia(
          mainDb,
          action,
          matches_flat,
          matches_info,
          teams_info.teams,
          gameScoringType,
          cb_ammend,
          pathViews
        )
      }
      const { gsValues, forMedia, forPlayoffs, usePure } = getGsCallValues(opts)
      if (gsValues.sheetName) {
        const _latestSeason = opts?.latestSeason || latestSeason
        fn_cls.getGoogleSheetRange(gsValues || gls_score, cb_gs, null, gsValues?.ignoreStartCase, null, _latestSeason, forPlayoffs, forMedia, usePure)
      }
    }, []);

  const handleGet_gsRankings = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsCallalues(opts)
      fn_cls.getGoogleSheetRange(
        gsValues || gls_score,
        callback,
        null,
        null,
        null,
        latestSeason)
    }, []);

  const handleGet_gsRosters = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsCallalues(opts)
      fn_cls.getGoogleSheetRange(gsValues ? gsValues : gls_score, callback)
    }, []);

  return {
    getMedia_results,
    handleGet_gsMatches,
    handleGet_gsRankings,
    handleGet_gsRosters,
    linkValues,
  }

}

export default useGoogleSports